import { ConfigTranslationEntities, ConfigTranslationKey } from './keys'

/**
 * This file is separate as this can be used in FE and BE code
 *
 * In the BE, we don't currently apply config translations - we just use the no-op function
 */

// For convenience, you can pass null/undefined entityId
// However, translation **will not** work in that case
type TranslatableConfigTranslationKey<T extends ConfigTranslationEntities> = Omit<ConfigTranslationKey<T>, 'entityId'> & {
  entityId: string | null | undefined
}

export interface ConfigTranslationFunction<T extends ConfigTranslationEntities = ConfigTranslationEntities> {
  // Overloads:
  // If we have a defaultValue, we can definitely return a string
  (key: TranslatableConfigTranslationKey<T>, defaultValue: string): string
  // If we don't have a defaultValue, we might return undefined
  (key: TranslatableConfigTranslationKey<T>, defaultValue: string | undefined): string | undefined
}

// We have a completely static noop function if we don't have the i18n instance
// No messing with referential stability
// Overloads:
// If we have a defaultValue, we can definitely return a string
export function noOpConfigTranslationFunction<T extends ConfigTranslationEntities>(
  key: TranslatableConfigTranslationKey<T>,
  defaultValue: string
): string
// If we don't have a defaultValue, we might return undefined
export function noOpConfigTranslationFunction<T extends ConfigTranslationEntities>(
  key: TranslatableConfigTranslationKey<T>,
  defaultValue: string | undefined
): string | undefined
// Actual implementation
export function noOpConfigTranslationFunction<T extends ConfigTranslationEntities>(
  key: TranslatableConfigTranslationKey<T>,
  defaultValue: string | undefined
): string | undefined {
  return defaultValue
}
